<template>
  <v-container>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <v-switch
            v-model="useCallingAeTitle"
            :loading="firstLoading"
            :class="{ 'disable-events': !savingEnable }"
            @change="saveDisabled = false"
            :label="$t('Filter using calling AE Title')"
            dense
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" class="text-right hidden-sm-and-down">
          <v-btn
            class="mr-4"
            color="grey darken-1"
            :loading="reloadLoading"
            v-if="savingEnable"
            @click="reload"
            outlined
            tile
          >
            <v-icon left>mdi-autorenew</v-icon>{{ $t("reload") }}
          </v-btn>
          <v-btn
            color="primaryLigth"
            :loading="saveLoading"
            :disabled="saveDisabled"
            v-if="savingEnable"
            @click="save"
            outlined
            tile
          >
            <v-icon left>mdi-content-save-outline</v-icon>{{ $t("save") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <v-switch
            v-model="forceExpiration"
            :loading="firstLoading"
            :class="{ 'disable-events': !savingEnable }"
            @change="saveDisabled = false"
            :label="$t('Force Expiration')"
            dense
          ></v-switch>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <v-switch
            v-model="tokenAuthentication"
            :loading="firstLoading"
            :class="{ 'disable-events': !savingEnable }"
            @change="saveDisabled = false"
            :label="$t('Token Authentication')"
            dense
          ></v-switch>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="nameSplitter"
            :items="nameSplitterItems"
            :loading="firstLoading"
            :class="{ 'disable-events': !savingEnable }"
            @change="saveDisabled = false"
            :label="$t('Split Names')"
            dense
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="expirationTimeout"
            :loading="firstLoading"
            :class="{ 'disable-events': !savingEnable }"
            @input="saveDisabled = false"
            :label="$t('Expiration Timeout (Seconds)')"
            type="number"
            dense
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="charset"
            :items="charsetItems"
            :loading="firstLoading"
            :class="{ 'disable-events': !savingEnable }"
            @change="saveDisabled = false"
            :label="$t('Character Set')"
            dense
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="3">
          <v-select
            v-model="selectedScript"
            :items="getScriptsItems"
            :label="$t('Script Name')"
            required
            @change="changeScriptSelect"
            :no-data-text="$t('Empty')"
          ></v-select>
        </v-col>
        <v-col cols="12" md="9" class="mt-3">
          <v-btn
            class="mr-4"
            color="primary darken-1"
            outlined
            tile
            @click="newScriptModal = true"
          >
            <v-icon left>mdi-file-plus-outline</v-icon>{{ $t("add") }}
          </v-btn>
          <v-btn
            class="mr-4"
            color="red darken-1"
            outlined
            tile
            @click="deleteScript"
          >
            <v-icon left>mdi-file-remove-outline</v-icon>{{ $t("delete") }}
          </v-btn>
          <v-btn
            class="mr-4"
            color="primary darken-1"
            outlined
            tile
            @click="evaluate"
          >
            <v-icon left>mdi-file-check-outline</v-icon>{{ $t("evaluate") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <v-textarea
            :label="$t('Script Source')"
            v-model="scriptSource"
            @change="changeCodeSource"
            @keydown="keydownCodeSource"
            :error-messages="scriptSourceError"
            :success-messages="scriptSourceSuccess"
            outlined
          ></v-textarea>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="text-right hidden-md-and-up pl-6 pr-6 mb-6">
      <v-btn
        class="mr-4"
        color="grey darken-1"
        :loading="reloadLoading"
        @click="reload"
        outlined
        tile
      >
        <v-icon left>mdi-autorenew</v-icon>{{ $t("reload") }}
      </v-btn>
      <v-btn
        color="primaryLigth"
        :loading="saveLoading"
        :disabled="saveDisabled"
        @click="save"
        outlined
        tile
      >
        <v-icon left>mdi-content-save-outline</v-icon>{{ $t("save") }}
      </v-btn>
    </v-container>

    <!-- New worklist script name input -->
    <v-dialog v-model="newScriptModal" persistent max-width="290">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("New Script") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  :label="$t('Name')"
                  v-model="newScriptName"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="newScriptModalClose">
            {{ $t("close") }}
          </v-btn>
          <v-btn text @click="newScriptModalSave">
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import EventBus from "../../event-bus";
import Charset from "../../lists/charset";
import Splitter from "../../lists/splitter";

export default {
  data: () => ({
    firstLoading: true,
    saveLoading: false,
    saveDisabled: true,
    reloadLoading: false,
    forceExpiration: null,
    expirationTimeout: 0,
    useCallingAeTitle: null,
    tokenAuthentication: null,
    savingEnable: false,
    charset: "Default",
    charsetItems: Charset,
    nameSplitter: "Disabled",
    nameSplitterItems: Splitter,
    middleware: [],
    selectedScript: null,
    selectedScriptOld: null,
    newScriptModal: false,
    newScriptName: null,
    scriptSource: null,
    scriptSourceError: null,
    scriptSourceSuccess: null,
  }),
  mounted() {
    // Permissions
    let configuration = this.$store.getters.resources.configuration;

    if (configuration.worklist.update) {
      this.savingEnable = true;
    }

    this.loadData();
  },
  computed: {
    getScriptsItems: function () {
      var list = new Array();

      for (var i = 0; i < this.middleware.length; i++) {
        list.push({
          text: this.middleware[i].name,
          value: i,
        });
      }

      return list;
    },
  },
  methods: {
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    loadData() {
      axios({
        url: "/api/v1/config/worklist",
        method: "GET",
      })
        .then((response) => {
          // load worklist data
          this.useCallingAeTitle = response.data.worklist.useCallingAeTitle;
          this.forceExpiration = response.data.worklist.forceExpiration;
          this.expirationTimeout = response.data.worklist.expirationTimeout;
          this.tokenAuthentication = response.data.worklist.tokenAuthentication;
          this.charset = response.data.worklist.charset;
          this.nameSplitter = response.data.worklist.nameSplitter;
          this.middleware = response.data.worklist.middleware;
          // stop loadings
          this.reloadLoading = false;
          this.firstLoading = false;
          this.saveDisabled = true;
        })
        .catch((error) => {
          this.reloadLoading = false;
          this.firstLoading = false;
          this.sendError(error);
        });
    },
    reload() {
      this.reloadLoading = true;
      this.loadData();
    },
    save() {
      this.saveLoading = true;

      axios
        .put("/api/v1/config/worklist", {
          useCallingAeTitle: this.useCallingAeTitle,
          forceExpiration: this.forceExpiration,
          expirationTimeout: Number(this.expirationTimeout),
          tokenAuthentication: this.tokenAuthentication,
          charset: this.charset,
          nameSplitter: this.nameSplitter,
          middleware: this.middleware,
        })
        .then((response) => {
          this.saveLoading = false;
          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.sendError(response.data.error);
          } else {
            this.saveDisabled = true;
          }
        })
        .catch((error) => {
          this.saveLoading = false;
          this.sendError(error);
        });
    },
    evaluate() {
      axios
        .post("/api/v1/config/test/worklist", {
          name: this.middleware[this.selectedScript].name,
          source: this.scriptSource,
        })
        .then((response) => {
          if (!response.data || !response.data.status) {
            this.sendError(response.data.error);
          } else {
            if (response.data.status == "error") {
              this.scriptSourceSuccess = null;
              this.scriptSourceError = response.data.message;
            } else {
              this.scriptSourceSuccess = "OK";
              this.scriptSourceError = null;
            }
          }
        })
        .catch((error) => {
          this.sendError(error);
        });
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
    newScriptModalClose() {
      this.newScriptName = null;
      this.newScriptModal = false;
    },
    newScriptModalSave() {
      this.saveDisabled = false;
      // save previous script
      if (this.selectedScript !== null) {
        this.middleware[this.selectedScript].source = this.scriptSource;
      }
      // add new script
      this.middleware.push({
        name: this.newScriptName,
        enabled: true,
        source: null,
      });
      // select new script
      this.selectedScript = this.middleware.length - 1;
      this.selectedScriptOld = this.selectedScript;
      // reset props
      this.newScriptModal = false;
      this.newScriptName = null;
      this.scriptSource = null;
      this.scriptSourceSuccess = null;
      this.scriptSourceError = null;
    },
    changeScriptSelect() {
      if (this.selectedScriptOld !== null) {
        this.middleware[this.selectedScriptOld].source = this.scriptSource;
      }
      this.scriptSource = this.middleware[this.selectedScript].source;
      this.selectedScriptOld = this.selectedScript;
      this.scriptSourceSuccess = null;
      this.scriptSourceError = null;
    },
    changeCodeSource() {
      this.saveDisabled = false;
      this.middleware[this.selectedScript].source = this.scriptSource;
    },
    keydownCodeSource() {
      this.scriptSourceSuccess = null;
      this.scriptSourceError = null;
    },
    deleteScript() {
      this.saveDisabled = false;
      this.middleware.splice(this.selectedScript, 1);
      if (this.middleware.length > 0) {
        this.selectedScript = 0;
        this.selectedScriptOld = 0;
        this.scriptSource = this.middleware[this.selectedScript].source;
      } else {
        this.selectedScript = null;
        this.selectedScriptOld = null;
      }
      this.scriptSourceSuccess = null;
      this.scriptSourceError = null;
    },
  },
};
</script>

<style scoped>
.disable-events {
  pointer-events: none;
}
</style>